export default __webpack_public_path__ + "images/tex1_100_674b1928a64fba6bacd01fc75658ba4a.jpg";